import React, { useEffect, useState } from 'react';
import Home from './sections/Home';
import Footer from './components/Footer';
import Header from './components/Header';
import Careers from './sections/Careers';
import ClientReviews from './sections/ClientReviews';
import Contact from './sections/Contact';
import GalleryV2 from './sections/Gallery-v2';
import Products from './sections/Products';

type SectionName = 'home' | 'gallery' | 'contact' | 'careers';
type Theme = 'dark' | 'light';

const PublicApp: React.FC = () => {
  const [activeSection, setActiveSection] = useState<SectionName>('home');
  const [activeTheme, setActiveTheme] = useState<Theme>('dark');

  useEffect(() => {
    const sections = document.querySelectorAll('section[data-section]');

    const observer = new IntersectionObserver(
      (entries: IntersectionObserverEntry[]) => {
        const visibleSections = entries
          .filter(entry => entry.isIntersecting)
          .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);

        if (visibleSections.length > 0) {
          const section = visibleSections[0].target;
          const sectionName = section.getAttribute('data-section') as SectionName;
          const theme = (section.getAttribute('data-theme') || 'dark') as Theme;

          if (sectionName) {
            setActiveSection(sectionName);
          }
          setActiveTheme(theme);
        }
      },
      { threshold: 0.3 }
    );

    sections.forEach(section => observer.observe(section));
    return () => observer.disconnect();
  }, []);

  return (
    <div id="app-container">
      <Header activeSection={activeSection} activeTheme={activeTheme} />
      <main>
        <section id="home-section" data-section="home" data-theme="dark">
          <Home />
        </section>

        <section id="gallery-section" data-section="gallery" data-theme="dark">
          <GalleryV2 />
        </section>

        <ClientReviews />

        <section id="contact-section" data-section="contact" data-theme="dark">
          <Contact />
        </section>

        <section id="products-section" data-section="products" data-theme="dark">
          <Products />
        </section>

        <section id="careers-section" data-section="careers" data-theme="dark">
          <Careers />
        </section>

      </main>
      <Footer />
    </div>
  );
};

export default PublicApp;